module.exports = __webpack_public_path__ + "img/car4.af7151d5.jpg";